import * as React from 'react'
import { Button } from 'react-bootstrap'

import './EditImageButton.scss'

interface Props {
	onClick: () => void
	disabled?: boolean
}

const EditImageButton = (props: Props) => {
	return (
		<div className="edit-image-button">
			{props.disabled && (
				<div className="edit-image-button__message">
					Please save your changes
					<br />
					before editing images
				</div>
			)}
			{!props.disabled && (
				<Button
					bsStyle={'primary'}
					bsSize="small"
					className="edit-image-button__button"
					style={{
						opacity: 1,
					}}
					onClick={props.onClick}
				>
					Edit Image
				</Button>
			)}
		</div>
	)
}

export default EditImageButton
